const FILTER_LAYOUT = {
  snippets: [
    [
        { key: "search", col: { md: 4, }},
        { key: "status", col: { md: 2, }},
        { key: "createDate", col: { md: 3, }},
        { key: "updateDate", col: { md: 3, }},
    ],
    [
        { key:"products", col: { md: 3, }},
        { key:"sections", col: { md: 3, }},
        { key:"createdBy", col: { md: 3, }},
        { key:"updatedBy", col: { md: 3, }},
    ],
  ],

  documents: [
    [
        { key: "RIS", col: { md: 1 }},
        { key: "PSIS", col: { md: 1 }},
    ],
    [
        { key: "search", col: { md: 4, }},
        { key: "status", col: { md: 2, }},
        { key: "createDate", col: { md: 3, }},
        { key: "updateDate", col: { md: 3, }},
    ],
    [
        { key: "region", col: { md: 3}}, 
        { key: "business", col: { md: 3, }}, 
        { key: "products", col: { md: 3, }},
        { key: "sections", col: { md: 3, }},
    ],
    [
        { key: "snippets", col: { md: 3, }},
        { key: "statusWorkflow", col: { md: 3, }},
        { key: "createdBy", col: { md: 3, }},
        { key: "updatedBy", col: { md: 3, }},
    ],
  ],

  bulk: [
    [
        { key: "RIS", col: { md: 1 }},
        { key: "PSIS", col: { md: 1 }},
    ],
    [
        { key: "search", col: { md: 4, }},
        { key: "status", col: { md: 2, }},
        { key: "createdBy", col: { md: 3, }},
        { key: "createDate", col: { md: 3, }},
    ],
    [
        { key: "region", col: { md: 3}}, 
        { key: "business", col: { md: 3, }},
        { key: "products", col: { md: 3, }},
        { key: "sections", col: { md: 3, }},
    ],
    [
        
        { key: "snippets", col: { md: 3, }},
        { key: "updatedBy", col: { md: 3, }},
        { key: "updateDate", col: { md: 3, }},
    ],
  ],

  sections: [
    [
        { key: "search", col: { md: 4, }},
        { key: "status", col: { md: 2, }},
        { key: "createDate", col: { md: 3, }},
        { key: "updateDate", col: { md: 3, }},
    ],
    [
        { key: "region", col: { md: 2, }}, 
        { key: "business", col: { md: 2, }}, 
        { key: "products", col: { md: 2, }}, 
        { key: "snippets", col: { md: 2, }},
        { key: "createdBy", col: { md: 2, }}, 
        { key: "updatedBy", col: { md: 2, }},
    ],    
  ],

  documentsCenter: [
    [
        { key: "RIS", col: { md: 1 }},
        { key: "PSIS", col: { md: 1 }},
    ],
    [
        { key: "search", col: { md: 6, }},
        { key: "createDate", col: { md: 3 }},
        { key: "updateDate", col: { md: 3 }},
    ],
    [
        { key: "region", col: { md: 4 }}, 
        { key: "business", col: { md: 4 }}, 
        { key: "products", col: { md: 4 }}
    ],
  ]
};

export default FILTER_LAYOUT;
